/**
 * Shared dependencies
 */
import type { RecipeListItem } from '../../shared/types/lists';

/**
 * Fetches the list items associated with the current user's lists from the Valio API.
 * @link https://evermade.stoplight.io/docs/valio-app/7hcdvvoht6s60-get-users-user-id-lists-list-id-items
 * @return {Promise<RecipeListItem[]>} A promise that resolves to an array of user list items.
 */
export async function getUserListItems(listId: string): Promise<RecipeListItem[]> {
	const { host } = window.valioConfig;
	const { session } = window.valioApp;

	// Ensure the session is initialized
	if (!session.initialized) {
		await session.init();
	}

	// Ensure the user is authenticated
	if (!session.userId) {
		return [];
	}

	const headers = await session.authHeader();

	return fetch(`${host}/api/v1/users/${session.userId}/lists/${listId}/items`, {
		method: 'GET',
		headers,
	})
		.then(async (response) => {
			if (!response.ok) {
				// Handle HTTP errors like 401, 404, 500, etc.
				const errorText = await response.text();
				throw new Error(`API Error: ${response.status} ${response.statusText} - ${errorText}`);
			}

			return await response.json();
		})
		.catch((error) => {
			console.error('Error fetching user lists:', error);
			throw error;
		});
}
